import { render, staticRenderFns } from "./PowerChart.vue?vue&type=template&id=0fe22428&lang=pug"
import script from "./PowerChart.vue?vue&type=script&lang=js"
export * from "./PowerChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports